import { useMemo } from 'react';
import { useFlightDeckArtifact } from '@atlassiansox/flight-deck-frontend-client';
import { FD_CLIENT_FETCH_PROPS } from './constants';
const transformArtifactsWithOverrides = (artifact, overrideKeys) => {
  var _artifact$overrides;
  if (!(artifact !== null && artifact !== void 0 && (_artifact$overrides = artifact.overrides) !== null && _artifact$overrides !== void 0 && _artifact$overrides.length) || overrideKeys.length === 0) {
    return artifact;
  }
  return overrideKeys.reduce((acc, overrideKey) => {
    var _artifact$overrides$f;
    return {
      ...acc,
      ...(artifact.overrides && ((_artifact$overrides$f = artifact.overrides.find(override => override.key === overrideKey)) === null || _artifact$overrides$f === void 0 ? void 0 : _artifact$overrides$f.item) || null)
    };
  }, artifact);
};
export const usePeopleAndTeamsRemoteArtifact = (product, locale, overridesKeys) => {
  const dimensions = useMemo(() => ({
    ...FD_CLIENT_FETCH_PROPS.dimensions,
    locale
  }), [locale]);
  const artifact = useFlightDeckArtifact(FD_CLIENT_FETCH_PROPS.name, dimensions);

  /**
   * FlightDeck doesn't allow custom, a 'product', dimension so we must handle this ourselves.
   * We can probably remove this memo once that functionality is available
   */
  return useMemo(() => {
    const productArtifact = artifact ? product in artifact['people-menu'] ? artifact['people-menu'][product] : artifact['people-menu'].default : null;
    return {
      ['people-menu']: transformArtifactsWithOverrides(productArtifact, overridesKeys ? overridesKeys['people-menu'] : [])
    };
  }, [artifact, product, overridesKeys]);
};